import React from 'react'
import "./projects.css"
import Works from './Works'


function Projects() {
  return (
    <section className="portfolio section" id="portfolio">
            <h2 className='section_title'>Portfolio</h2>
            <span className='section_subtitle'>My Projects</span>

            <Works/>

    </section>
  )
}

export default Projects